import React from "react";
import {
  Card,
  CardBody,
  Typography,
} from "@material-tailwind/react";

import {
  CurrencyDollarIcon,
  BanknotesIcon,
  ClockIcon,
  ArrowUturnLeftIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  TrophyIcon,
  ReceiptPercentIcon,
} from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";

const SummaryCards = ({ summary = {} }) => {

  const { t } = useTranslation("home");
  const cards = [
    {
      title: t("summaryCards.totalOrderValue"),
      value: summary.total_order_value ?? 0,
      icon: CurrencyDollarIcon,
      bg: "bg-blue-50",
      text: "text-blue-700",
    },
    {
      title: t("summaryCards.totalReceived"),
      value: summary.total_received ?? 0,
      icon: BanknotesIcon,
      bg: "bg-green-50",
      text: "text-green-700",
    },
    {
      title: t("summaryCards.pendingAmount"),
      value: summary.total_pending ?? 0,
      icon: ClockIcon,
      bg: "bg-orange-50",
      text: "text-orange-700",
    },
    {
      title: t("summaryCards.refundAmount"),
      value: summary.refund_amount ?? 0,
      icon: ArrowUturnLeftIcon,
      bg: "bg-red-50",
      text: "text-red-700",
    },
    // {
    //   title: "Today's Collection",
    //   value: summary.today_collection ?? 0,
    //   icon: CalendarDaysIcon,
    //   bg: "bg-purple-50",
    //   text: "text-purple-700",
    // },
    // {
    //   title: "This Month",
    //   value: summary.this_month_collection ?? 0,
    //   icon: ChartBarIcon,
    //   bg: "bg-indigo-50",
    //   text: "text-indigo-700",
    // },
    // {
    //   title: "Largest Payment",
    //   value: summary.largest_payment ?? 0,
    //   icon: TrophyIcon,
    //   bg: "bg-yellow-50",
    //   text: "text-yellow-700",
    // },
    // {
    //   title: "Collection %",
    //   value: `${summary.collection_percentage ?? 0}%`,
    //   icon: ReceiptPercentIcon,
    //   bg: "bg-cyan-50",
    //   text: "text-cyan-700",
    // },
  ];

  const formatCurrency = (value) => {
    if (typeof value === "string") return value;

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "SAR",
      maximumFractionDigits: 2,
    }).format(value);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {cards.map((card, index) => {
        const Icon = card.icon;

        return (
          <Card
            key={index}
            className="border border-blue-gray-100 shadow-sm hover:shadow-lg transition-all duration-300"
          >
            <CardBody className="flex items-center justify-between">
              <div>
                <Typography
                  variant="small"
                  color="blue-gray"
                  className="font-medium"
                >
                  {card.title}
                </Typography>

                <Typography
                  variant="h5"
                  className="mt-2 font-bold"
                >
                  {typeof card.value === "string"
                    ? card.value
                    : formatCurrency(card.value)}
                </Typography>
              </div>

              <div
                className={`rounded-full p-4 ${card.bg}`}
              >
                <Icon className={`h-7 w-7 ${card.text}`} />
              </div>
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
};

export default SummaryCards;